<template>
    <div div class="cdl-input">
        <input type="date" class="not-empty" :value="modelValue" @input="onInput"  />
        <label>{{ label }}</label>
    </div>
</template>


<script setup>
import {defineProps, defineEmits} from "vue"

defineProps(['modelValue', 'label'])

const emit = defineEmits(['update:modelValue'])

function onInput(e) {
  const value = e.target.value
  emit('update:modelValue', value)
}
</script>
